<template>
  <div class="top-bar">
    <div class="top-bar-left">
      <a href="/" class="top-bar-logo">
        <img :src="require('@/assets/img/logo_2026.svg')" class="top-bar-logo-image" alt="ITS logo">
      </a>
    </div>
    <div class="top-bar-middle">
      <MainLinks />
    </div>
    <div class="top-bar-right">
      <div class="top-bar__functionals">
        <ContrastSwitcher></ContrastSwitcher>
        <FontsizeSwitcher></FontsizeSwitcher>
        <LanguageSwitcher />
      </div>
      <div class="top-bar__mobile-conent">
        <MobileMenu />
        <v-btn 
          @click="toggleMobileMenu"
          class="top-bar__menu-switcher"
          variant="text"
          title="Menu">
            <v-icon v-if="!showMobileMenu" size="35">mdi-menu</v-icon>
            <v-icon v-else size="35">mdi-close</v-icon>
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {
  computed, defineComponent, ref, Ref, onMounted,
}                         from 'vue';
import useOptions         from '@/components/composers/useOptions';
import useHandleDrawer    from '@/components/composers/useHandleDrawer';
import MainIcon           from '@/components/structural/MainIcon.vue';
import ContrastSwitcher   from '@/components/structural/ContrastSwitcher.vue';
import FontsizeSwitcher   from '@/components/structural/FontsizeSwitcher.vue';
import LanguageSwitcher   from '@/components/structural/LanguageSwitcher.vue';
import useOverlay         from '@/components/composers/useOverlay';
import store              from '@/store/index';
import { ILinkElement } from '@/interfaces/ILinkElement';
import MobileMenu from './MobileMenu.vue';
import MainLinks from './MainLinks.vue';

const TopBar = defineComponent({
  name: 'TopBar',
  components: {
    MainIcon,
    ContrastSwitcher,
    FontsizeSwitcher,
    LanguageSwitcher,
    MainLinks,
    MobileMenu,
  },
  setup() {
    const getContrastActive: Ref<boolean> = computed((): boolean => store.getters.getContrastActive);
    const showMobileMenu: Ref<boolean> = computed((): boolean => store.state.showMobileMenu);
    const menuSwitcher: Ref<boolean> = ref(false);
    const overlay = useOverlay();

    const closeSwitcher = (): boolean => {
      menuSwitcher.value = false;
      return true;
    };

    const showMap = () => {
      closeSwitcher();
      overlay.hideOverlay();
    };

    const switchRoute = (routeName: string): void => {
      closeSwitcher();
      overlay.showOverlay();
    };

    const menuToggle = () => {
      menuSwitcher.value = !menuSwitcher.value;
    };

    const toggleMobileMenu = () => {
      store.commit('toggleMobileMenu');
    };
    const selectedRoute: Ref<string> = computed(() => store.state.currentRoute.name as string);

    onMounted(() => {
      // if (selectedRoute.value !== 'Map') {
      //   overlay.showOverlay();
      // }
    });

    return {
      menuSwitcher,
      showMobileMenu,
      toggleMobileMenu,
      closeSwitcher,
      showMap,
      switchRoute,
      menuToggle,
      getContrastActive,
      selectedRoute,
      ...useHandleDrawer(),
      ...useOptions(),
      ...overlay,
    };
  },
});
export default TopBar;
</script>

<style scoped lang="scss">

.top-bar {
  background-color: $main-bg-color;
  color: $main-font-color;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 10px;
  box-shadow: 0px 3px 17px 0px rgba(0, 0, 0, 0.5);
  border: 2px solid $nav-layers-box-border;

  .mobile-app & {
    position: absolute;
  }

  &-left {
    @include width-from($mobile) {
      width: 25%; 
    }
  }

  &-right {
    display: flex;
    align-items: center;
    @include width-from($mobile) {
      width: 25%; 
      justify-content: flex-end;
    }
  }

  &-middle {
    @include width-until($mobile) {
      display: none;
    }
    @include width-from($mobile) {
      width: 50%; 
      justify-content: center;
    }
  }

  &__functionals {
    display: flex;
    align-items: center;

    @include width-until($mobile) {
      display: none;
    }
  }

  &__links {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }

  &__link {
    text-decoration: none;
    color: $main-font-color;
    font-weight: 500;
    margin-left: 20px;
  }

  &-logo {
    text-decoration: none;
    color: white;
    font-weight: 700;
    display: flex;
    align-items: center;
    font-size: rem(20px);
    max-width: 500px;

    @include width-until($mobile) {
      font-size: 14px;
    }

    &-char {
      margin-left: 10px;
      max-width: 50px;

      @include width-until($mobile) {
        max-width: 30px;
      }
    }
    &-image {
      margin-right: 10px;
      width: 100%;


      @include width-until($mobile) {
      }
    }

    &:hover {
      text-decoration: none;
    }
  }
  &__language-btn {
    font-size: 35px;
  }

  &__mobile-conent {
    @include width-from($mobile) {
      display: none;
    }

    .mobile-app & {
      display: inline-block;
      top: 12px;
      position: fixed;
      right: 12px;
      z-index: 3333;
      background-color: $main-bg-color;
    }
  }
}

.temp__sticky-nav {
  position: fixed;
  right: 0;
  top: 30%;
  z-index: 223;
  display: flex;
  align-items: flex-start;
  cursor: pointer;
  transform: translateX(100px);
  transition: .5s;

  &:hover {
    transform: translateX(0);
  }
}

.temp__stiky-controller {
  font-size: rem(25px);
  padding: rem(14px);
  background-color: gray;
}

.temp__stiky-content {
  background-color: gray;
}

.topbar {
  overflow: hidden;
  position: fixed;
  top: 0;
  right: 0;

  &:deep(.v-toolbar__content)  {
    padding-top: 0;
    padding-bottom: 0;
  }

  &__header {
    height: 100%;
    z-index: 3;
    padding-left: rem(33px);
    display: flex;
    justify-content: flex-start;
    align-items: center;
    position: relative;
    text-decoration: none;

    &:before {
      content: '';
      display: block;
      position: absolute;
      background-color: white;
      left: rem(24px);
      border-radius: 50%;
      height: rem(290px);
      width: 5.125rem;
      z-index: -2;
    }
  }

  &__main-logo {
    width: rem(75px);
    height: rem(95px);
  }

  &__title {
    font-size: rem(28px);
    font-weight: 900;
    letter-spacing: rem(3px);
    margin-left: rem(10px);
    background-color: white;
  }

  &__layer-switchers {
    display: flex;
    flex-direction: column;
  }

  &__menu-switcher {
    position: absolute;
    top: rem(10px);
    right: rem(10px);
    z-index: 3;

    .mobile-app & {
      position: fixed;
    }
  }

  &__right-side {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  &__sidebar-switcher {
    min-height: 60px;
    min-width: 60px;
    margin-left: rem(20px);
    margin-right: rem(10px);
    transition: all 0.3s ease-in-out;

    &--active {
      background-color: rgba(255, 255, 255, .1);
      transition: all 0.3s ease-in-out;
    }

    i {
      font-size: rem(55px);

      // @media #{map_get($display-breakpoints, 'sm-and-down')} {
      //   font-size: rem(35px);
      // }
    }
  }
}
</style>
